/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_InsightsInputs */

const en_why_listening_advantage_insights = /** @type {(inputs: Why_Listening_Advantage_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI overviews and key points`)
};

const es_why_listening_advantage_insights = /** @type {(inputs: Why_Listening_Advantage_InsightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resúmenes y puntos clave con IA`)
};

/**
* | output |
* | --- |
* | "AI overviews and key points" |
*
* @param {Why_Listening_Advantage_InsightsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_insights = /** @type {((inputs?: Why_Listening_Advantage_InsightsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_InsightsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_insights(inputs)
	return en_why_listening_advantage_insights(inputs)
});